module.exports = __webpack_public_path__ + "img/icon-apartment.5ae334cb.svg";